export const tr = {
    'archived-experiment-name': 'Deneme {experimentId}'
};
